<template>
  <div>
    <FreelancersMenu menu="freelancers" :type="type"></FreelancersMenu><br />
    <CCard>
      <CCardHeader>
        <slot name="header">
          Promotores
          <div class="card-header-actions" style="width: 600px; margin-right: 5px;">
            <CRow>      
              <CCol md="8" style="text-align: right;"></CCol>                           
              <CCol md="4" style="text-align: right;">
                <CSelect class="m-0"
                  :value.sync="regionSelect" 
                  :options="regionOptions"
                  @change="changeFilters"
                />  
              </CCol>                           
            </CRow>
          </div>
        </slot>
      </CCardHeader>
      <CCardBody>
        <CRow>      
          <CCol md="12">
            <CDataTable 
              :hover="true"
              :striped="true"
              :border="true"
              :small="true"
              :fixed="true"
              :items="items"
              :fields="fields"
              :dark="false"
              style="width: 100%; font-size: 11px;"
            >           
              <template #name="{item}"><td class= "text-left w400" style="text-transform: uppercase;">{{item.name}}</td></template>
              <template #region="{item}"><td class= "text-center w200">{{item.region}}</td></template>
              <template #bank="{item}"><td class= "text-center w200">{{item.bank}}{{item.bank == 'BBVA' ? ' - '+item.account : ''}}<br />{{item.clabe}}</span></td></template>
              <template #account="{item}"><td class= "text-center w200">{{item.account ? item.account : '-'}}</td></template>
              <template #clabe="{item}"><td class= "text-center w200">{{item.clabe ? item.clabe : '-'}}</td></template>
              <template #email="{item}"><td class= "text-center w200">
                {{item.email ? item.email : '-'}}
                <span><br /><br /><CButton v-if="item.token" color="success" size="sm" @click="login(item)">Iniciar Sesión</CButton> <CButton color="info" size="sm" @click="showPassword(item)">Ver Contraseña</CButton></span>
              </td></template>
              <template #is_active="{item}"><td class= "text-center w50">{{item.is_active ? 'Activo' : 'Inactivo'}}</td></template>
              <template #actions="{item}">
                <td class="table_actions b3">
                  <CButton color="success" size="sm" @click="deactivate(item)" v-if="item.is_active">Reactivar</CButton>
                  <CButton color="danger" size="sm" @click="activate(item)" v-if="!item.is_active">Inactivar</CButton>
                </td>
              </template>
            </CDataTable>
            <ul class="pagination justify-content-start" style="font-size: 10px;">

              <!-- First -->
              <li class="page-item" :class="{ disabled: pagination.current === 1 }">
                <a class="page-link" href="#" @click.prevent="changeFilters(1)">«</a>
              </li>

              <!-- Prev -->
              <li class="page-item" :class="{ disabled: !pagination.prev }">
                <a class="page-link" href="#"
                  @click.prevent="changeFilters(pagination.current - 1)">‹</a>
              </li>

              <!-- Pages -->
              <li v-for="page in pages"
                  :key="page"
                  class="page-item"
                  :class="{ active: page === pagination.current }">
                <a class="page-link" href="#"
                  @click.prevent="changeFilters(page)">
                  {{ page }}
                </a>
              </li>

              <!-- Next -->
              <li class="page-item" :class="{ disabled: !pagination.next }">
                <a class="page-link" href="#"
                  @click.prevent="changeFilters(pagination.current + 1)">›</a>
              </li>

              <!-- Last -->
              <li class="page-item" :class="{ disabled: pagination.current === pagination.last }">
                <a class="page-link" href="#"
                  @click.prevent="changeFilters(pagination.last)">»</a>
              </li>

            </ul>

          </CCol>    
        </CRow>
      </CCardBody>
    </CCard>

    <ShowPasswordModal ref="showPasswordModal"></ShowPasswordModal>
  </div>
</template>
<script>

import store from '../../store'
import ws from '../../services/freelancers';
import FreelancersMenu from './FreelancersMenu.vue';
import ShowPasswordModal from '../../components/freelancers/ShowPasswordModal.vue';

export default {
  name: 'FreelanceVisits',
  components: {
    FreelancersMenu,
    ShowPasswordModal
  },
  data () {
    return {
      code: 'general',
      items: [],
      fields: [
          {key: 'name', label: 'Nombre', _style:" font-size: 12px;"},
          {key: 'region', label: 'Zona', _style:" font-size: 12px;"},
          {key: 'bank', label: 'Banco', _style:" font-size: 12px;"},
          {key: 'email', label: 'Usuario', _style:" font-size: 12px;"},
          {key: 'actions', label: 'Acciones', _style:" font-size: 12px;"},
        ],
      customerSelect: "",
      customersOptions: [],
      kamSelect: "",
      kamsOptions: [],
      monthSelect: "202409",
      monthsOptions: [],
      regionSelect: "TODAS",
      regionOptions: [
        {value: 'TODAS', label: 'TODAS LAS ZONAS'}, 
        {value: 'AGUASCALIENTES', label: 'AGUASCALIENTES'}, 
        {value: 'BAJA CALIFORNIA NORTE', label: 'BAJA CALIFORNIA NORTE'}, 
        {value: 'BAJA CALIFORNIA SUR', label: 'BAJA CALIFORNIA SUR'}, 
        {value: 'CAMPECHE', label: 'CAMPECHE'}, 
        {value: 'CHIAPAS', label: 'CHIAPAS'}, 
        {value: 'CHIHUAHUA', label: 'CHIHUAHUA'}, 
        {value: 'COAHUILA', label: 'COAHUILA'}, 
        {value: 'COLIMA', label: 'COLIMA'}, 
        {value: 'DURANGO', label: 'DURANGO'}, 
        {value: 'GUANAJUATO', label: 'GUANAJUATO'}, 
        {value: 'GUERRERO', label: 'GUERRERO'}, 
        {value: 'HIDALGO', label: 'HIDALGO'}, 
        {value: 'JALISCO', label: 'JALISCO'}, 
        {value: 'MEXICO', label: 'MÉXICO'},
        {value: 'MICHOACAN', label: 'MICHOACÁN'}, 
        {value: 'MORELOS', label: 'MORELOS'}, 
        {value: 'NAYARIT', label: 'NAYARIT'}, 
        {value: 'NUEVO LEON', label: 'NUEVO LEÓN'}, 
        {value: 'OAXACA', label: 'OAXACA'}, 
        {value: 'PUEBLA', label: 'PUEBLA'}, 
        {value: 'QUERETARO', label: 'QUERÉTARO'}, 
        {value: 'QUINTANA ROO', label: 'QUINTANA ROO'}, 
        {value: 'SAN LUIS POTOSI', label: 'SAN LUIS POTOSÍ'}, 
        {value: 'SINALOA', label: 'SINALOA'}, 
        {value: 'SONORA', label: 'SONORA'}, 
        {value: 'TABASCO', label: 'TABASCO'}, 
        {value: 'TAMAULIPAS', label: 'TAMAULIPAS'}, 
        {value: 'TLAXCALA', label: 'TLAXCALA'}, 
        {value: 'VERACRUZ', label: 'VERACRUZ'}, 
        {value: 'YUCATAN', label: 'YUCATÁN'}, 
        {value: 'ZACATECAS', label: 'ZACATECAS'}
      ],
      pagination: {
        current: 1,
        last: 1,
        perPage: 0,
        total: 0,
        next: null,
        prev: null
      },
      type: 'administrator'
    }
  },
  mounted: async function() {
    await this.changeFilters(1);

    let is_administrator = localStorage.getItem("is_administrator");
    let is_kam = localStorage.getItem("is_kam");

    if(is_administrator == "true"){
      this.type = "administrator"
    }
    else{
      if(is_kam == "true"){
        this.type = "kam"
      }
    }
  },
  computed: {
    pages() {
      let start = Math.max(this.pagination.current - 2, 1)
      let end = Math.min(start + 4, this.pagination.last)

      return Array.from(
        { length: end - start + 1 },
        (_, i) => start + i
      )
    }
  },
  methods: {
    async changeFilters (page) {
      this.loading();
        let filters = {
          region: this.regionSelect,
          page: page
        };
        
        let response = await ws.getFreelancers(filters);

        if(response.type == "success"){
          this.items = response.paginate.data;     
          
          const r = response.paginate;

          this.pagination.current = r.current_page
          this.pagination.last = r.last_page
          this.pagination.perPage = r.per_page
          this.pagination.total = r.total
          this.pagination.next = r.next_page_url
          this.pagination.prev = r.prev_page_url
        }
      this.loaded();
    },
    async rejectModal (item) {
      this.$refs.visitRejectModal.showVisitModal(item);
    },
    async showPassword (item) {
      this.$refs.showPasswordModal.showPasswordModal(item);
    },
    async activate (item) {
      this.loading();

        let response = await ws.activateFreelancer(item.id);

        this.showToast(response.type, response.message)
        
      this.loaded();

      await this.changeFilters(1);
    },
    async deactivate (item) {
      this.loading();        

        let response = await ws.deactivateFreelancer(item.id);

        this.showToast(response.type, response.message)
        
      this.loaded();

      await this.changeFilters(1);
    },
    login (item) {
      localStorage.setItem("admin_token", localStorage.getItem("token"));

      if(window.location.hostname != 'localhost'){
        window.location = "https://circuito.tmkt3.com/#/"+item.token+"/login-link";
      }
      else{
        window.location = "http://"+window.location.hostname+":"+window.location.port+"/#/"+item.token+"/login-link";
      }
    },
    showToast(type, message){
        store.commit('toast', {color: type, message: message});
    },
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'danger'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'success'
      }
      return $color
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style>
.warning{
 background-color: #F9B115;
}
.success{
  background-color: #1B9E3E;
}
.danger{
  background-color: #E55353
}
.other{
  background-color: #6b7785
}
.card.success{
  color:black !important;
  font-weight: bold !important;
}
.card-header-actions select{
  font-size: 12px;
}
.card-header{
  font-size: 20px;
  padding: 10px 15px 10px 20px;

}
</style>
